{
  "requiredField": "Champ obligatoire",
  "firstName": {
    "required": "Champ obligatoire",
    "invalidChars": "Ne doit pas contenir de chiffres"
  },
  "lastName": {
    "required": "Champ obligatoire",
    "invalidChars": "Ne doit pas contenir de chiffres"
  },
  "email": {
    "incorrect": "Adresse email invalide"
  },
  "phone": {
    "required": "Le téléphone est obligatoire"
  },
  "password": {
    "required": "Veuillez remplir ce champ",
    "short": "Le mot de passe doit contenir au moins 8 caractères",
    "large": "Le mot de passe doit contenir au maximum 64 caractères",
    "mismatch": "Les mots de passe ne correspondent pas"
  },
  "terms": {
    "required": "Vorte accord est nècessaire pour continuer"
  },
  "company": {
    "nameRequired": "Le nom de l’entreprise est obligatoire",
    "typeRequired": "Le type de l’entreprise est obligatoire",
    "nifRequired": "Le NIF est obligatoire",
    "regionRequired": "La région est obligatoire",
    "cityRequired": "La ville est obligatoire",
    "activitySpheresRequired": "Le domaine d’activité est obligatoire",
    "economicActivitiesRequired": "Le secteur d’activité économique est obligatoire",
    "managerRequired": "Le responsable est obligatoire",
    "descriptionRequired": "La description de l’entreprise est obligatoire"
  },
  "vacancy": {
    "nameRequired": "Champ obligatoire",
    "cityRequired": "Champ obligatoire",
    "regionRequired": "Veuillez sélectionner une région",
    "candidatesCountRequired": "Champ obligatoire",
    "responsibleRequired": "Le responsable est obligatoire",
    "currencyRequired": "Veuillez sélectionner la devise",
    "descriptionRequired": "La description est obligatoire",
    "salaryFromRequired": "Veuillez entrer le salaire minimum",
    "salaryToRequired": "Veuillez entrer le salaire maximum",
    "salaryMinValue": "Le salaire doit être supérieur à 0",
    "salaryComparison": "Le salaire maximum doit être supérieur ou égal au minimum",
    "requirementsMandatory": "Les exigences obligatoires sont nécessaires",
    "requirementsAdditional": "Les exigences supplémentaires sont nécessaires",
    "responsibilitiesRequired": "Champ obligatoire",
    "employmentTypesRequired": "Veuillez sélectionner au moins un type d’emploi",
    "paymentPeriodRequired": "Veuillez sélectionner une période de paiement",
    "scheduleRequired": "Veuillez sélectionner un horaire de travail",
    "skillsRequired": "Veuillez sélectionner au moins une compétence",
    "activeFromRequired": "La date de début d'activité est obligatoire",
    "activeToRequired": "La date de fin d'activité est obligatoire",
    "interviewFinalMessageRequired": "Message pour les personnes intéressées est obligatoire",
    "activitySpheresRequired": "Le domaine d’activité est obligatoire",
    "tariffRequired": "Veuillez sélectionner un tarif"
  },
  "activity": {
    "startDateComprasion": "La date de début doit être supérieure ou égale à la date actuelle",
    "typeRequired": "Veuillez sélectionner un type d’activité",
    "startDateRequired": "La date de début est obligatoire lorsque vous choisissez une période",
    "endDateRequired": "La date de fin est obligatoire lorsque vous choisissez une période",
    "dateComparison": "La date de fin doit être postérieure à la date de début"
  },
  "role": {
    "required": "Le groupe est obligatoire"
  }
}
